import { ObjectValuesType } from 'addiction-components';

export const AccessesChartPoint = {
	ACCESS_NUMER: 'accessNumber',
	LOGIN_NUMBER: 'loginNumber',
} as const;
export type AccessesChartPoint = ObjectValuesType<typeof AccessesChartPoint>;
